/* global DocumentTouch */
// Import everything from autoload
import 'jquery'; // eslint-disable-next-line import/no-unresolved, import/extensions

import './vendor/dropdown.js';
import './vendor/flickity.pkgd.min.js';
import './vendor/mixitup-multifilter.min.js';
import './vendor/mixitup-pagination.min.js';
import './vendor/modal.js';
import './vendor/slick.js';
import './vendor/xpandy-polyfill.min.js';
import mixitup from 'mixitup';
import Dropdown from './vendor/dropdown';
import Filtering from './filtering';
import PostFiltering from './post-filtering';
import PortcoFiltering from './portco-filtering';
import MicroModal from './vendor/modal';
import Xpandy from './vendor/xpandy-polyfill.min'; // eslint-disable-next-line import/no-unresolved, import/extensions

import '../../modules/Calltoaction/assets/scripts/main.js';
import '../../modules/Casestudies/assets/scripts/main.js';
import '../../modules/Companies/assets/scripts/main.js';
import '../../modules/Contact/assets/scripts/main.js';
import '../../modules/Contact/assets/scripts/styles.js';
import '../../modules/Hero/assets/scripts/main.js';
import '../../modules/Iconcards/assets/scripts/main.js';
import '../../modules/Numbers/assets/scripts/animateValues.js';
import '../../modules/Numbers/assets/scripts/main.js';
import '../../modules/Tabs/assets/scripts/main.js';
jQuery(function () {
  // Custom Dropdowns
  // Wrap Select Inputs
  Dropdown({
    selector: 'select'
  }); //Filtering

  if ($('.js-filtering').length) {
    Filtering();
  }

  if ($('.post-filtering').length) {
    PostFiltering();
  }

  if ($('.transactions-filtering').length) {
    CompanyFiltering();
  }

  if ($('.portco-filtering').length) {
    PortcoFiltering();
  }

  if ('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
    document.documentElement.className = document.documentElement.className.replace(/\bno-touch\b/, 'touch');
  }

  var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame; // ---------------------------------------------------------------------
  // Header fade effect on homepage
  // initialize modal

  MicroModal.init({
    disableScroll: true,
    // [5]
    awaitCloseAnimation: true,
    // [7]
    debugMode: false // [8]

  });
  var header = document.querySelector('.Header');

  var headerHomepageFade = function headerHomepageFade() {
    if (window.pageYOffset < 40) {
      header.classList.add('is-top');
    } else {
      header.classList.remove('is-top');
    }

    raf(headerHomepageFade);
  };

  if (document.querySelector('body')) {
    headerHomepageFade();
  } // ---------------------------------------------------------------------
  // General page animations
  // if (window.IntersectionObserver) {
  //   const observer = new IntersectionObserver(
  //     (entries, obs) => {
  //       entries.forEach(entry => {
  //         if (entry.isIntersecting) {
  //           entry.target.classList.remove('is-hidden');
  //           entry.target.classList.add('is-visible');
  //           obs.unobserve(entry.target);
  //         }
  //       });
  //     },
  //     { rootMargin: '0px 0px -200px 0px' }
  //   );
  //   document
  //     .querySelectorAll('main > section:not(.no-anim)')
  //     .forEach(section => {
  //       section.classList.add('is-hidden');
  //       observer.observe(section);
  //     });
  // }
  // let sectionsNodes = document.querySelectorAll('main > section:not(.no-anim)');
  // // let buffer = 200;
  // let sections = Array.from(sectionsNodes).map(section => {
  //     section.classList.add('is-hidden');
  //     return {
  //         section: section,
  //         bottom: section.getBoundingClientRect().bottom
  //     };
  // });
  // const sectionAnimations = () => {
  //     let windowBottom = window.pageYOffset + window.innerHeight;
  //     sections.forEach(section => {
  //         if (section.bottom < windowBottom) {
  //             section.section.classList.remove('is-hidden');
  //             section.section.classList.add('is-visible');
  //         }
  //     });
  //     raf(sectionAnimations);
  // };
  // if (sections.length) {
  //     sectionAnimations();
  // }
  // ---------------------------------------------------------------------


  var xpandyRoot = document.querySelector('.Xpandy');

  if (xpandyRoot) {
    var xpandy = new Xpandy('.Xpandy', {
      autoCloseOnOpen: true,
      items: '.Xpandy-item',
      arrow: true,
      arrowPosition: 'right',
      equalHeights: false,
      previewTemplate: function previewTemplate(config) {
        return "\n                <div class=\"Xpandy-wrapper\">\n                    ".concat(config.arrow ? '<div class="Xpandy-arrow"></div>' : '', "\n                    <div class=\"Xpandy-container\">\n                        <div class=\"Xpandy-body\">\n                            <div class=\"Xpandy-wrap\">\n                                <div class=\"Xpandy-close--wrapper\">\n                                    <span class=\"Xpandy-close\"></span>\n                                </div>\n                                <div class=\"Xpandy-base\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                ");
      },
      callbacks: {
        onInit: function onInit() {
          if (document.querySelector('.js-filtering')) Filtering();
        },
        onClose: function onClose() {},
        onOpen: function onOpen() {}
      }
    });

    if (window.location.hash) {
      var xpandySlug = window.location.hash.substr(1);
      var xpandyTarget = document.querySelector(".".concat(xpandySlug));

      if (xpandyTarget) {
        xpandy[0].togglePreview(xpandyTarget);
        xpandyTarget.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest'
        });
      }
    }
  }

  if (document.querySelector('.js-filtering') && !document.querySelector('.Xpandy')) {
    Filtering();
  }

  if (document.querySelector('.js-teamfiltering')) {
    mixitup('.js-teamfiltering', {
      animation: {
        duration: 250,
        nudge: true,
        easing: 'ease-out',
        reverseOut: false,
        effects: 'fade'
      }
    });
    document.getElementById('teamOpen').click();
  } // -----------------------------------------------


  function disableTouchMove(e) {
    e.preventDefault();
  }

  function openActions() {
    document.documentElement.classList.add('u-lockWindow');
    document.body.classList.add('u-lockWindow');
    document.documentElement.addEventListener('touchmove', disableTouchMove, false);
  }

  function closeActions() {
    document.documentElement.classList.remove('u-lockWindow');
    document.body.classList.remove('u-lockWindow');
    document.documentElement.removeEventListener('touchmove', disableTouchMove, false);
  } // let debounceResize = debounce(function () {
  //     if (window.innerWidth > 1180 && header.classList.contains('mobile-is-open')) {
  //         toggleMenu();
  //     }
  // }, 250);
  // window.addEventListener('resize', debounceResize);


  var mobileIcon = document.querySelector('.mobile-menu');
  var headerLogo = document.querySelector('.Header-logo');
  var footerIcon = document.querySelector('.link--offsite--mobile');

  var toggleMenu = function toggleMenu(e) {
    e.preventDefault();
    var nav = document.querySelector('.Nav-ul');
    nav.classList.toggle('is-open');
    mobileIcon.classList.toggle('is-open');
    footerIcon.classList.toggle('is-open');
    headerLogo.classList.toggle('is-open');
    document.body.classList.toggle('is-open');

    if (nav.classList.contains('is-open')) {
      openActions();
    } else {
      closeActions();
    }
  };

  mobileIcon.addEventListener('click', toggleMenu); //Mobile Menu

  var wrapperMenu = document.querySelector('.mobile-menu');
  wrapperMenu.addEventListener('click', function () {
    wrapperMenu.classList.toggle('open');
    $('html, body').toggleClass('is-locked');
    $('.MobileMenu').toggleClass('is-active');
    $('.ModalBackground').toggleClass('is-active');
    $('.Header').toggleClass('is-active');
  }); // ---------------------------------------------------------------------
  //Cascading Mobile

  $('nav .Nav-ul > .menu-item-has-children > a').click(function (e) {
    e.preventDefault(); // $(this)
    //     .parent()
    //     .find('.sub-menu')
    //     .toggle();

    $('.submenu-is-open').removeClass('submenu-is-open');
    $(this).parent().toggleClass('submenu-is-open');
  });
  $('.sub-menu').prepend($('<a class="GoBackMobile"><img src="/app/themes/windpoint/resources/assets/images/ui-goback.svg" alt="goback"></a>'));
  $('.GoBackMobile').click(function () {
    $(this).parent().parent().removeClass('submenu-is-open');
  }); // ---------------------------------------------------------------------
  // ---------------------------------------------------------------------
  // $('.menu-item-has-children > a').on('click', e => {
  //   if (window.innerWidth <= 1024) {
  //     e.preventDefault();
  //     $(this)
  //       .parent()
  //       .find('.sub-menu')
  //       .toggle();
  //     $(this)
  //       .parent()
  //       .toggleClass('submenu-is-open');
  //   }
  // });
  // $( '.menu-item-has-children > a' ).on( 'click', function() {
  // $('.menu-item-has-children > a').click(function(e) {
  //   if (window.innerWidth <= 1199) {
  //     e.preventDefault();
  //     $(this)
  //       .parent()
  //       .find('.sub-menu')
  //       .toggle();
  //     $(this)
  //       .parent()
  //       .toggleClass('submenu-is-open');
  //   }
  // });
  // ---------------------------------------------------------------------

  var submenu = document.querySelector('.Hero-submenu');

  if (window.innerWidth < 950 && submenu) {
    var active = submenu.querySelector('.active');
    var wrap = submenu.querySelector('.wrap');
    var scrollLeft = active.offsetLeft;

    if (scrollLeft > window.innerWidth) {
      wrap.scrollLeft = scrollLeft;
    }
  }

  $('.GroupedContent-single:first-child').addClass('is-active');
  $(window).scroll();
});